module.exports = __webpack_public_path__ + "images/line_friend_lp/btn-line_bce9d5314de167d959268aeedc073feb.png";